import { render, staticRenderFns } from "./livecode.vue?vue&type=template&id=df98066a&scoped=true"
import script from "./livecode.vue?vue&type=script&lang=js"
export * from "./livecode.vue?vue&type=script&lang=js"
import style0 from "./livecode.vue?vue&type=style&index=0&id=df98066a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df98066a",
  null
  
)

export default component.exports